import React from 'react';

export const Video = () => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        fill='none'
        width='18'
        height='18'
        viewBox='0 0 25 25'
    >
        <polygon stroke='#38373C' points='22.13,12.29 4.74,22.34 4.74,2.25 '/>
    </svg>
);
